import _ from 'lodash';

const initialState = {
    show: false,
    component: null
}

export default function reducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case "TOAST_SET_SHOW": {
            return {
                ...state,
                show: action.show,
            }
        }
        case "TOAST_SET_COMPONENT": {
            return {
                ...state,
                component: action.component,
            }
        }

        case "TOAST_RESET": 
            return {
                ...initialState
            }

        default:
            return state;
    }
}